// import React, { useEffect, useState } from "react";
// import { Modal } from "react-bootstrap";
// import "./TimerModal.css";
// import * as animationData from "./TimerMadal.json";
// import Lottie from "react-lottie";

// const TimerModal = ({ show, handleClose, message }) => {
//   const [count, setCount] = useState(5);

//   useEffect(() => {
//     if (!show) return;

//     setCount(5);

//     const interval = setInterval(() => {
//       setCount((prev) => {
//         if (prev <= 1) {
//           clearInterval(interval);
//           handleClose();
//           return 0;
//         }
//         return prev - 1;
//       });
//     }, 1000);

//     return () => clearInterval(interval);
//   }, [show]);

//   const defaultOptions = {
//     loop: true,
//     animationData: animationData,
//     rendererSettings: {
//       preserveAspectRatio: "xMidYMid slice",
//     },
//   };

//   return (
//     <Modal
//       show={show}
//       // onHide={handleClose}
//       centered
//       className="success_modal_div"
//     >
//       <Modal.Body className="success_modal text-center">
//         <div className="success_lottie">
//           <Lottie className="me-auto lottie" options={defaultOptions} />
//         </div>

//         <h3 className="mt-3 text-danger lottie_text">
//           Your Test Will Start In {count} sec
//         </h3>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default TimerModal;

import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "./TimerModal.css";
import * as animationData from "./TimerMadal.json";
import Lottie from "react-lottie";

const TimerModal = ({ show, handleClose, onCancel, onCountdownFinish }) => {
  const [count, setCount] = useState(5);
  const [isCounting, setIsCounting] = useState(false);

  useEffect(() => {
    if (!show) {
      setCount(5);
      setIsCounting(false);
      return;
    }

    setCount(5);
    setIsCounting(true);

    const interval = setInterval(() => {
      setCount((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setIsCounting(false);
          handleClose();
          // Trigger fullscreen and test start
          onCountdownFinish?.();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [show, handleClose, onCountdownFinish]);

  const defaultOptions = {
    loop: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Modal
      show={show}
      centered
      className="success_modal_div"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body className="success_modal text-center">
        <div className="success_lottie">
          <Lottie className="me-auto lottie" options={defaultOptions} />
        </div>

        <h3 className="mt-3 text-danger lottie_text">
          Your Test Will Start In {count} sec
        </h3>

        <button
          className="btn btn-secondary mt-3"
          onClick={onCancel}
          style={{ minWidth: "100px" }}
        >
          Cancel
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default TimerModal;
